<template>
  <div class="container">
    <div v-show="isVisible" class="my-xl-3 py-xl-3" :class="{

        'col-lg-12': true

    }" >

    <!--checkbox-->
    <div class="row justify-content-center" >
        <div class="col col-auto">
          <label class="form-label" > <input type="checkbox" v-model="notChecked" id="checkbox"><span style="margin-right: 10px"></span>zapoznałam/em się z warunkami umowy </label>
        </div>
    </div>

      <!--button-->
    <div class="row justify-content-center">
        <div class="col col-auto"><!--
          <button ref="submit" key="sign-button" class="SignContractButton" :disabled="!isDisabled"  @click="signContract"> {{ label }} </button>-->
          <a  key="btn-next"  :class="{
                                  disabled:!isDisabled
                                }"
              class="form-button btn btn-outline-primary btn-lg me-2"
              @click="signContract" > {{ label }}</a>
        </div>
    </div>


<!-- <main>
<div class="button" @click="onSubmit">
    <div class="text" >Submit</div>
  </div>


  <div class="progress-bar"></div>
  <svg x="0px" y="0px"
     viewBox="0 0 25 30" style="enable-background:new 0 0 25 30;">
    <path ref="check" class="check st0" d="M2,19.2C5.9,23.6,9.4,28,9.4,28L23,2"/>
  </svg>
</main> -->




    </div>
  </div>
</template>

<script>


    import anime from 'animejs/lib/anime.es.js';



    export default {
        name: "SignContract",

        computed: {


            isDisabled(){
                return this.notChecked;
            }

        },


        data(){
            return {

                notChecked: false,

                isVisible: true,


                basicTimeline: anime.timeline({
                  autoplay: false
                })

            }
        },


        props: {


            label: {
                type: String,
                required: true
            }

        },



        methods: {


            signContract(){


                //this.basicTimeline.play();
                this.$emit('signed');

            },


            onSubmit(){

               // alert('click')
//console.log('timeline is  ')

          //      console.log(this.basicTimeline)


              //  this.basicTimeline.play();


            }




        },





        created() {


            this.listen('visibility', (bind, checked ) => {

                bind.split(',').indexOf(this.name) > -1
                    && (this.isVisible = checked);
            });




        },

        mounted(){






          /*  var pathEls = this.$refs['check']; //$(".check");
            for (var i = 0; i < pathEls.length; i++) {
              var pathEl = pathEls[i];
              var offset = anime.setDashoffset(pathEl);
              pathEl.setAttribute("stroke-dashoffset", offset);
            }*/

            this.basicTimeline
             /* .add({
                targets: ".text",
                duration: 1,
                opacity: "0"
              })*/
              .add({
                targets: this.$refs['submit'], //".button",
                duration: 1300,
                height: 20,
                width: 300,
                backgroundColor: "#2B2D2F",
                border: "1",
                borderRadius: 100
              });

             /* .add({
                targets: ".progress-bar",
                duration: 2000,
                width: 300,
                easing: "linear"
              })
              .add({
                targets: ".button",
                width: 0,
                duration: 1
              })
              .add({
                targets: ".progress-bar",
                width: 80,
                height: 80,
                delay: 500,
                duration: 750,
                borderRadius: 80,
                backgroundColor: "#71DFBE"
              })
              .add({
                targets: pathEl,
                strokeDashoffset: [offset, 0],
                duration: 200,
                easing: "easeInOutSine"
              });*/

/*$(".button").click(function() {
  basicTimeline.play();
});

$(".text").click(function() {
  basicTimeline.play();
});*/







        }
    }
</script>


<style scoped>
    a{
      width: 300px;
      height: 55px;
      vertical-align: middle;
      text-align: center;
      line-height: 35px;
    }
  .btn-outline-primary.disabled {
    background-color: #045439;
  }
  @media (max-width:481px){
    a{
      width: 240px;
      height:55px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      line-height: 35px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/SignContract.vue